var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c("autocomplete", {
    ref: "autocompletePersonDocument",
    staticStyle: { width: "100%" },
    attrs: {
      "auto-select": "",
      search: _vm.filterPeople,
      "get-result-value": _vm.getPeopleResult,
      "debounce-time": 500,
    },
  })
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }